export const DS_STEP_FORM_ID = 'ds-step-form';
